// import Icon from "../../assets/icons/Icon";

// const Button = ({
//   isActive = false,
//   type = "primary",
//   submit = false,
//   loading = false,
//   children,
//   onClick,
//   iconType,
//   px = "px-3",
//   disabled = false,
//   showFullWidth
// }) => {
//   // Base styles that apply to all buttons
//   const baseStyles = `
//     h-[34px] ${px} rounded-lg font-medium
//     transition-all duration-200
//     flex items-center justify-center ${showFullWidth &&"w-full"}
//     ${(loading || disabled) ? 'cursor-not-allowed opacity-70' : 'cursor-pointer'}
//   `;

//   // Primary button styles
//   const primaryStyles = `
//     text-white bg-gradient-to-r from-indigo-500 to-purple-500
//     ${!(loading || disabled) && 'hover:from-indigo-600 hover:to-purple-600'}
//     shadow-md ${!(loading || disabled) && 'hover:shadow-lg'}
//   `;

//   // Secondary button styles
//   const secondaryStyles = `
//     text-gray-700 bg-white border border-gray-200
//     ${!(loading || disabled) && 'hover:bg-gray-50 hover:text-gray-800'}
//     shadow-sm
//   `;

//   // Active state styles (if needed)
//   const activeStyles = isActive ? `
//     ring-2 ring-offset-2 ring-indigo-500
//   ` : '';

//   // Combine all styles
//   const buttonClassNames = `
//     ${baseStyles}
//     ${type === "primary" ? primaryStyles : secondaryStyles}
//     ${activeStyles}
//   `.replace(/\s+/g, ' ').trim(); // Remove extra spaces

//   return (
//     <button
//       type={submit ? "submit" : "button"}
//       onClick={onClick}
//       className={buttonClassNames}
//       disabled={loading || disabled}
//       aria-disabled={loading || disabled}
//     >
//       {loading ? (
//         "Loading..."
//       ) : (
//         <>
//           {iconType && (
//             <span className="w-5 mr-[4px]">
//               <Icon type={iconType} />
//             </span>
//           )}
//           {children}
//         </>
//       )}
//     </button>
//   );
// };

// export default Button;

import Icon from "../../assets/icons/Icon";

const Button = ({
  isActive = false,
  type = "primary",
  submit = false,
  loading = false,
  children,
  onClick,
  iconType,
  px = "px-3",
  disabled = false,
  showFullWidth = false,
}) => {
  const baseStyles = `
    h-[34px]
    ${px}
    rounded-lg
    font-medium
    transition-all
    duration-200
    flex
    items-center
    justify-center
    ${showFullWidth ? "w-full" : ""}
    ${loading || disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer"}
  `;

  /* ✅ Primary – uses your global CSS gradient */
  const primaryStyles = `
    primary-button-gradient
    shadow-md
    ${!(loading || disabled) ? "hover:shadow-lg" : ""}
  `;

  /* Secondary – clean + neutral */
  const secondaryStyles = `
    text-gray-700
    bg-white
    border
    border-gray-200
    shadow-sm
    ${!(loading || disabled) ? "hover:bg-gray-50 hover:text-gray-800" : ""}
  `;

  const activeStyles = isActive
    ? "ring-2 ring-offset-2 ring-indigo-500"
    : "";

  const buttonClassNames = `
    ${baseStyles}
    ${type === "primary" ? primaryStyles : secondaryStyles}
    ${activeStyles}
  `
    .replace(/\s+/g, " ")
    .trim();

  return (
    <button
      type={submit ? "submit" : "button"}
      onClick={onClick}
      className={buttonClassNames}
      disabled={loading || disabled}
      aria-disabled={loading || disabled}
    >
      {loading ? (
        <span className="animate-pulse">Loading...</span>
      ) : (
        <>
          {iconType && (
            <span className="w-5 mr-1 flex items-center">
              <Icon type={iconType} />
            </span>
          )}
          {children}
        </>
      )}
    </button>
  );
};

export default Button;
